interface AddressObject {
  addressLine1: string;
  addressLine2?: string;
  country: string;
  subdivision?: string;
  zipCode: string;
  city: string;
}

export const isAddressEmpty = ({
  addressLine1,
  addressLine2,
  city,
  country,
  subdivision,
  zipCode,
}: AddressObject): boolean => {
  return !addressLine1 && !addressLine2 && !city && !country && !subdivision && !zipCode;
};
